import create from 'zustand'
import {ApexFont, MapPosition} from "../utils/interfaces";
import {EMPTY_FONT} from "../utils/constants";
//import {DEFAULT_FONT, EMPTY_FONT} from "../constants/constants";


interface FontState {
    fontHistory: Array<ApexFont>;
    currFont: ApexFont;
    holdFontStr: string;
    prevFontStr: string;
    currFontStr: string;
    currX: number;
    currY: number;
    currMapPosition: MapPosition;
    addToHistory: (font: ApexFont) => void;
}

const useFontStore = create<FontState>((set, get) => ({
    fontHistory: [],
    currFont: EMPTY_FONT,
    holdFontStr: 'HotSalsa-Regular',
    prevFontStr: 'Arial',
    currFontStr: 'HotSalsa-Regular',
    currX: 179,
    currY: 163,
    currMapPosition: {x: 179, y: 163},
    addToHistory: (font: ApexFont) => {
        //console.log('add', font);
        if(!font._fontName || get().fontHistory.includes(font)) return;
        set((state) => ({
            fontHistory: [
                ...state.fontHistory,
                font,
            ]
        }))
    },
}))

export default useFontStore;